module.exports = __webpack_public_path__ + "static/media/zcdt_Jyjl.724f8a1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/zcdt_Jyjl.png
// module id = 1881
// module chunks = 0 1